import { match, P } from 'ts-pattern';
import { CALENDAR_VIEW, CALENDAR_VIEW_KEY } from '@studio/constants/calendar';
import UrlPaths from '@studio/constants/url-paths';

const getCalendarDefaultPath = () => {
  try {
    const currentViewKey = localStorage.getItem(CALENDAR_VIEW_KEY);

    return match(currentViewKey)
      .with(P.union(CALENDAR_VIEW.DAY, UrlPaths.CALENDAR.DAY), () => UrlPaths.CALENDAR.DAY)
      .with(P.union(CALENDAR_VIEW.LIST, UrlPaths.CALENDAR.LIST), () => UrlPaths.CALENDAR.LIST)
      .with(P.union(CALENDAR_VIEW.WEEK, UrlPaths.CALENDAR.WEEK), () => UrlPaths.CALENDAR.WEEK)
      .otherwise(() => UrlPaths.CALENDAR.MONTH);
  } catch (error) {
    console.error('Failed to get calendar default path', error);
    return UrlPaths.CALENDAR.MONTH;
  }
};

export default getCalendarDefaultPath;
